module.exports = __webpack_public_path__ + "/hashedassets-launcher/launcher_meetings_new2.44695f4759b430e4dd40dced4947bd09.svg";